// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UZFgTnUqKFdI6u {
  margin: var(--ds-space-0, 0) -12px;
}
.UZFgTnUqKFdI6u > ul {
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  list-style: none;
}
.LOhIKSjx1ImXEH {
  border: none;
  background-color: transparent;
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  transition: none;
  border-radius: 0;
  outline: 0;
  background: var(--ds-background-neutral-subtle, #00000000);
  box-shadow: none;
  color: var(--ds-text, #172b4d);
  text-align: left;
  text-decoration: none;
}
.LOhIKSjx1ImXEH:hover {
  border: none;
  background-color: transparent;
  box-shadow: none;
  background: var(--ds-background-neutral-subtle-hovered, #091e420f);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.LOhIKSjx1ImXEH:active {
  border: none;
  background-color: transparent;
  box-shadow: none;
  background: var(--ds-background-neutral-subtle-pressed, #091e4224);
  color: var(--ds-text, #172b4d);
}
.LOhIKSjx1ImXEH.A_RC_DjUrClhFv:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .LOhIKSjx1ImXEH.A_RC_DjUrClhFv:focus {
  outline-color: -webkit-focus-ring-color;
}
.LOhIKSjx1ImXEH.A_RC_DjUrClhFv:focus .mac.firefox {
  outline-color: AccentColor;
}
.LOhIKSjx1ImXEH[disabled],
.LOhIKSjx1ImXEH[disabled]:active,
.LOhIKSjx1ImXEH[disabled]:focus,
.LOhIKSjx1ImXEH[disabled]:hover {
  background: transparent;
  /* stylelint-disable-next-line declaration-no-important */
  color: var(--ds-text-disabled, #091e424f) !important;
  cursor: not-allowed;
}
.LOhIKSjx1ImXEH[disabled] .ySpXXcIfrmAj4w svg,
.LOhIKSjx1ImXEH[disabled]:active .ySpXXcIfrmAj4w svg,
.LOhIKSjx1ImXEH[disabled]:focus .ySpXXcIfrmAj4w svg,
.LOhIKSjx1ImXEH[disabled]:hover .ySpXXcIfrmAj4w svg {
  /* stylelint-disable-next-line declaration-no-important */
  color: var(--ds-text-disabled, #091e424f) !important;
}
.LOhIKSjx1ImXEH[disabled] span[name='check'],
.LOhIKSjx1ImXEH[disabled]:active span[name='check'],
.LOhIKSjx1ImXEH[disabled]:focus span[name='check'],
.LOhIKSjx1ImXEH[disabled]:hover span[name='check'] {
  /* stylelint-disable-next-line declaration-no-important */
  color: var(--ds-icon-subtle, #626f86) !important;
}
.LOhIKSjx1ImXEH[disabled] .xAZRAlQvzWR693,
.LOhIKSjx1ImXEH[disabled]:active .xAZRAlQvzWR693,
.LOhIKSjx1ImXEH[disabled]:focus .xAZRAlQvzWR693,
.LOhIKSjx1ImXEH[disabled]:hover .xAZRAlQvzWR693 {
  /* stylelint-disable-next-line declaration-no-important */
  color: var(--ds-text-disabled, #091e424f) !important;
}
.bH80RvHHmoWYhk {
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: var(--ds-space-050, 4px);
  font-size: 14px;
  font-weight: var(--ds-font-weight-regular, 400);
  line-height: 20px;
}
.bH80RvHHmoWYhk.wz7UJENPuf2pDX {
  margin: var(--ds-space-0, 0);
}
.rOCUd832zSbpQb {
  display: flex;
  align-items: baseline;
  gap: var(--ds-space-100, 8px);
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px);
}
.rOCUd832zSbpQb:hover {
  background: var(--ds-background-neutral-subtle-hovered, #091e420f);
  color: var(--ds-text, #172b4d);
}
.rOCUd832zSbpQb.jY5ykSXdbBiojU {
  background: transparent;
  /* stylelint-disable-next-line declaration-no-important */
  color: var(--ds-text-disabled, #091e424f) !important;
  cursor: not-allowed;
}
.rOCUd832zSbpQb.jY5ykSXdbBiojU .xAZRAlQvzWR693 {
  /* stylelint-disable-next-line declaration-no-important */
  color: var(--ds-text-disabled, #091e424f) !important;
}
.rOCUd832zSbpQb .NEzgaJR7Ng8qCl {
  display: none;
}
.rOCUd832zSbpQb .ySpXXcIfrmAj4w {
  flex: 0 0 auto;
  opacity: 0;
}
.rOCUd832zSbpQb .NEzgaJR7Ng8qCl:checked ~ .ySpXXcIfrmAj4w {
  opacity: 1;
}
.rOCUd832zSbpQb .EXhLgUHntvmfic {
  flex: 0 0 auto;
}
.rOCUd832zSbpQb .hXaJ1wFMgdz9pM {
  flex: 1 1 auto;
  max-width: fit-content;
}
.g4oicM70jgqP7r {
  display: flex;
  align-items: center;
}
.IdDNa6bndLCcjy,
.cAwJIRkNM8FSaW {
  flex-shrink: 0;
  max-height: 20px;
  padding: var(--ds-space-0, 0) var(--ds-space-050, 4px);
}
.xAZRAlQvzWR693 {
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  font-weight: var(--ds-font-weight-regular, 400);
  line-height: 16px;
}
.tIz6r8m3gG1ooC {
  list-style: none;
}
.tIz6r8m3gG1ooC::after {
  content: ' ';
  display: block;
  height: 1px;
  margin: var(--ds-space-100, 8px) var(--ds-space-150, 10px);
  background-color: var(--ds-border, #091e4224);
}
.SjCNb4HrUypywp::after {
  margin-right: var(--ds-space-0, 0);
  margin-left: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var popoverMenu = `UZFgTnUqKFdI6u`;
export var link = `LOhIKSjx1ImXEH`;
export var linkFocusRing = `A_RC_DjUrClhFv`;
export var icon = `ySpXXcIfrmAj4w`;
export var description = `xAZRAlQvzWR693`;
export var item = `bH80RvHHmoWYhk`;
export var withoutMargins = `wz7UJENPuf2pDX`;
export var radio = `rOCUd832zSbpQb`;
export var disabled = `jY5ykSXdbBiojU`;
export var input = `NEzgaJR7Ng8qCl`;
export var checkmark = `EXhLgUHntvmfic`;
export var content = `hXaJ1wFMgdz9pM`;
export var title = `g4oicM70jgqP7r`;
export var iconBefore = `IdDNa6bndLCcjy`;
export var iconAfter = `cAwJIRkNM8FSaW`;
export var separator = `tIz6r8m3gG1ooC`;
var _1 = `SjCNb4HrUypywp`;
export { _1 as "separator--fullWidth" };
export default ___CSS_LOADER_EXPORT___;
